<template>
  <div class="l-block l-block--result l-mt-4">
    <div class="l-block__header">
      <div>
        選択数 : <span class="c-text--bold">{{ checked.length }}</span>
        <Button variant="border" fsize="f12" size="w120" @click="reset">
          <Icon variant="return_gn" :size="12" />
          選択を解除する
        </Button>
      </div>
      <ButtonDownload
        :items="items"
        :surveyDate="surveyDate"
        :url="competitorSiteDomain"
        :gscError="gscError"
      />
    </div>
    <div v-show="gscError" class="c-text--error c-text--bold">
      <Icon2 variant="attention" :size="12" />
      GSCアカウント連携に問題が発生したため、自社平均順位を取得できません。GSCアカウントの設定後に再度分析してください。
    </div>
    <VirtualList :items="customedItems" :itemSize="itemSize" ref="list">
      <template slot="header">
        <div class="c-virtual-list__head">
          <div class="c-virtual-list__col check"></div>
          <ThSort
            v-model="tmpSort"
            name="keyword"
            orderby="asc"
            tag="div"
            type="string"
            class="c-virtual-list__col keyword c-text--center"
            @change="changeSort"
          >
            キーワード
          </ThSort>
          <ThSort
            v-model="tmpSort"
            name="searchVolume"
            orderby="desc"
            tag="div"
            type="number"
            class="c-virtual-list__col search-volume c-text--center"
            @change="changeSort"
          >
            月間検索数
          </ThSort>
          <ThSort
            v-model="tmpSort"
            name="competitorSiteRank"
            orderby="asc"
            tag="div"
            type="number"
            class="c-virtual-list__col rank c-text--center"
            @change="changeSort"
          >
            競合順位
          </ThSort>
          <ThSort
            v-model="tmpSort"
            name="ownSiteRank"
            orderby="asc"
            tag="div"
            type="number"
            class="c-virtual-list__col rank c-text--center"
            @change="changeSort"
          >
            自社平均順位
          </ThSort>
          <ThSort
            v-model="tmpSort"
            name="rankGap"
            orderby="asc"
            tag="div"
            type="number"
            class="c-virtual-list__col gap c-text--center"
            @change="changeSort"
          >
            GAP
          </ThSort>
          <ThSort
            v-model="tmpSort"
            name="competitorSitePageUrl"
            orderby="asc"
            tag="div"
            type="string"
            class="c-virtual-list__col url c-text--center"
            @change="changeSort"
          >
            競合URL
          </ThSort>
          <ThSort
            v-model="tmpSort"
            name="ownSiteUrl"
            orderby="asc"
            tag="div"
            type="string"
            class="c-virtual-list__col url c-text--center"
            @change="changeSort"
          >
            自社URL
          </ThSort>
        </div>
      </template>
      <template slot="before">
        <div v-if="isLoading" class="c-virtual-list__guide">
          <div class="c-virtual-list__col l-p-0">
            <LoadingChara variant="inline">
              <template slot="title">
                データ取得中
              </template>
            </LoadingChara>
          </div>
        </div>
        <div v-else-if="!items.length" class="c-virtual-list__guide">
          <div class="c-virtual-list__col c-text--center">
            データがありません。
          </div>
        </div>
      </template>
      <template v-slot="{ item }">
        <ListItemCompetitiveSiteKeyword
          :item="item"
          :key="item.id"
          :project="project"
          :checked="checked"
          :gscError="gscError"
          @check="updateChecked"
        />
      </template>
    </VirtualList>
    <portal to="form-add-tasks">
      <transition name="v-fade">
        <FormAddTasks
          v-if="checked.length"
          :count="checked.length"
          :date="surveyDate"
          :items="checked"
          :project="project"
          @reset="addedTasks"
          defaultType="createContent"
          page="competitiveSiteKeyword"
          key="form"
        />
      </transition>
    </portal>
  </div>
</template>

<script>
import ListItemCompetitiveSiteKeyword from '@/components/competitiveSiteKeyword/ListItemCompetitiveSiteKeyword';
import Button from '@/components/Button';
import ButtonDownload from '@/components/competitiveSiteKeyword/ButtonDownload';
import FormAddTasks from '@/components/FormAddTasks';
import LoadingChara from '@/components/LoadingChara';
import Icon from '@/components/Icon';
import Icon2 from '@/components/Icon2';
import ThSort from '@/components/ThSort';
import VirtualList from '@/components/VirtualList';
import { scroller } from 'vue-scrollto/src/scrollTo';

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    gscError: {
      type: Boolean,
      required: false
    },
    sort: {
      type: Object,
      required: true
    },
    competitorSiteDomain: {
      type: String,
      required: true
    },
    surveyDate: {
      type: String,
      required: true
    },
    tasks: {
      type: Array,
      required: true
    },
    completedTasks: {
      type: Array,
      required: true
    }
  },
  components: {
    ListItemCompetitiveSiteKeyword,
    Button,
    ButtonDownload,
    FormAddTasks,
    Icon,
    Icon2,
    LoadingChara,
    VirtualList,
    ThSort
  },
  data() {
    return {
      itemSize: 43,
      scroller: scroller(),
      timer: null,
      checked: [],
      tmpSort: Object.assign({}, this.sort)
    };
  },
  computed: {
    customedItems() {
      const items = this.items.map(item => {
        return {
          ...item,
          hasTask: this.checkTask(item.keyword, this.tasks),
          completedTask: this.checkTask(item.keyword, this.completedTasks)
        };
      });
      return items;
    }
  },
  watch: {
    items: {
      handler() {
        this.$nextTick(() => {
          this.$refs.list.scrollToStart();
        });
      }
    }
  },
  methods: {
    updateChecked(checked) {
      this.checked = checked;
    },
    uncheckItem(item) {
      const checkedIndex = this.checked.indexOf(item);
      if (checkedIndex !== -1) {
        this.checked.splice(checkedIndex, 1);
      }
    },
    changeSort() {
      this.$emit('sort', this.tmpSort);
    },
    reset() {
      this.checked = [];
    },
    addedTasks() {
      this.reset();
      this.$emit('addedTasks');
    },
    checkTask(keyword, tasks) {
      const targetKeyword = keyword.toLowerCase();
      return tasks.some(task => {
        const taskKeyword = task.keyword.toLowerCase();
        return targetKeyword === taskKeyword;
      });
    }
  }
};
</script>
